exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CoverImage {\n  background-color: #eee;\n  background-position: center;\n  background-size: cover;\n}\n\n/*\n    .CoverImage--wide {\n        min-height: 150px;\n        padding-top: 30%;\n    }\n    .CoverImage--square {\n        @media (max-width: @screen-xs-max) {\n            padding-top: 60%;\n        }\n        @media (min-width: @screen-sm-min) {\n            padding-top: 80%;\n        }\n    }\n    */\n", ""]);

// exports
